interface HeartIconProps {
	color?: string;
}

export const HeartDarkIcon: React.FC<HeartIconProps> = ({ color = "#212B36" }) => {
	return (
		<svg
			fill="none"
			height="24"
			viewBox="0 0 24 24"
			width="24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.8754 3C15.3754 3 13.9504 3.6 12.9004 4.65L12.0004 5.55L11.1754 4.725C9.00039 2.475 5.40039 2.475 3.22539 4.65L3.15039 4.725C0.900391 6.975 0.900391 10.575 3.15039 12.825L12.0004 21.75L20.8504 12.825C23.1004 10.575 23.1004 6.975 20.8504 4.725C19.8004 3.6 18.3754 3 16.8754 3Z"
				fill={color}
			/>
		</svg>
	);
};
